import React from "react";
import * as FaIcons from "react-icons/fa";
import * as RiIcons from "react-icons/ri";
import * as BiIcons from "react-icons/bi";
import * as VscIcons from "react-icons/vsc";
import * as TiIcons from "react-icons/ti";
import * as GiIcons from "react-icons/gi";
import * as BsIcons from "react-icons/bs";
import * as TbIcons from "react-icons/tb";
import { FaPiggyBank } from 'react-icons/fa';
import { MdManageHistory } from "react-icons/md";
import { TbBusinessplan } from "react-icons/tb";
import { FaCrutch } from "react-icons/fa6";

import { IoBandageOutline } from "react-icons/io5";
import { BsCurrencyDollar } from "react-icons/bs";
import { BsTrophy } from "react-icons/bs";
import { GiStrong } from "react-icons/gi";
import { FaSearchDollar } from "react-icons/fa";
import { FaChartColumn } from "react-icons/fa6";
import { FaHandshake } from "react-icons/fa";
import { FaHandHoldingHeart } from "react-icons/fa6";
import { FaFileInvoiceDollar } from "react-icons/fa6";
import { FaCcVisa } from "react-icons/fa6";
import { TbCashRegister } from "react-icons/tb";
import { TiPrinter } from "react-icons/ti";
export const SidebarData = [
  {
    title: "Premiações",
    path: "/premiacoes",
    icon: <BsTrophy />,
    iconClosed: <RiIcons.RiArrowDropDownFill />,
    iconOpened: <RiIcons.RiArrowDropUpFill />,
    cName: "nav-text",
    subNav: [
      {
        title: "Alta Performance",
        path: "/premiacoes/performance",
        icon: <BsCurrencyDollar />,
        cName: "nav-text2",
      },
    ],
  },
    {
    title: "Gestão",
    path: "/gestao",
    icon: <MdManageHistory />,
    iconClosed: <RiIcons.RiArrowDropDownFill />,
    iconOpened: <RiIcons.RiArrowDropUpFill />,
    cName: "nav-text",
    subNav: [
      {
        title: "Desenvolvimento de Negócios",
        path: "/gestao/negocios",
        icon: <TbBusinessplan />,
        cName: "nav-text2",
      },
       {
        title: "Gestão Investimentos",
        path: "/gestao/investimentos",
        icon: <FaChartColumn />,
        cName: "nav-text2",
      },
    ],
  },
  {
    title: "META BASE",
    path: "/metabase",
    icon: <VscIcons.VscGraph />,
    iconClosed: <RiIcons.RiArrowDropDownFill />,
    iconOpened: <RiIcons.RiArrowDropUpFill />,
    cName: "nav-text",
    subNav: [
     {
        title: "Cooperados",
        path: "/metabase/cooperados",
        icon: <BiIcons.BiUser />,
        cName: "nav-text2",
      },
        {
        title: "Inadimplência",
        path: "/metabase/inadimplencia",
        icon: <FaSearchDollar />,
        cName: "nav-text2",
      },
        {
        title: "Crédito",
        path: "/metabase/credito",
        icon: <FaFileInvoiceDollar />,
        cName: "nav-text2",
      },
     /* {
        title: "Deposito à prazo",
        path: "/metabase/prazo",
        icon: <FaIcons.FaRegMoneyBillAlt />,
        cName: "nav-text2",
      },
      {
        title: "Deposito à vista",
        path: "/metabase/vista",
        icon: <FaIcons.FaMoneyBillAlt />,
        cName: "nav-text2",
      },*/
    ],
  },
  {
    title: "PRODUTOS",
    path: "/produtos",
    icon: <VscIcons.VscGraphLine />,
    iconClosed: <RiIcons.RiArrowDropDownFill />,
    iconOpened: <RiIcons.RiArrowDropUpFill />,
    cName: "nav-text",
    subNav: [
       {
        title: "Adquirência",
        path: "/produtos/adquirencia",
        icon: <TbCashRegister />,
        cName: "nav-text2",
      },
      /*{
        title: "Canais",
        path: "/produtos/canais",
        icon: <RiIcons.RiCellphoneFill />,
        cName: "nav-text2",
      },*/
    {
        title: "Cartões Visa",
        path: "/produtos/visa",
        icon: <FaCcVisa />,
        cName: "nav-text2",
      },
      {
        title: "Cobrança",
        path: "/produtos/cobranca",
        icon: <TiIcons.TiDocument />,
        cName: "nav-text2",
      },
       {
        title: "Consórcio",
        path: "/produtos/consorcio",
        icon: <FaHandshake />,
        cName: "nav-text2",
      },

      {
        title: "Domicilio",
        path: "/produtos/domicilio",
        icon: <TiPrinter />,
        cName: "nav-text2",
      },
       {
        title: "Fidelização",
        path: "/produtos/fidelizacao",
        icon: <FaHandHoldingHeart />,
        cName: "nav-text2",
      },
      /*{
        title: "Seguro Auto Elementar",
        path: "/produtos/AutoElementar",
        icon: <BiIcons.BiBuildings />,
        cName: "nav-text2",
      },
      {
        title: "Seguro Vida",
        path: "/produtos/vida",
        icon: <GiIcons.GiHeartShield />,
        cName: "nav-text2",
      },
      {
        title: "Título de Capitalização",
        path: "/produtos/capitalizacao",
        icon: <BiIcons.BiCoinStack />,
        cName: "nav-text2",
      },*/
      {
        title: "Previdência",
        path: "/produtos/previdencia",
        icon: <TbIcons.TbOld />,
        cName: "nav-text2",
      },
       {
        title: "Risco",
        path: "/produtos/risco",
        icon: <FaCrutch />,
        cName: "nav-text2",
      },
    ],
  },
 /* {
    title: "Bônus",
    path: "/Bonus",
    icon: <GiIcons.GiStarMedal />,
    iconClosed: <RiIcons.RiArrowDropDownFill />,
    iconOpened: <RiIcons.RiArrowDropUpFill />,
    cName: "nav-text",
    subNav: [
      {
        title: "Pendência Zero",
        path: "/bonus/pendencia",
        icon: <FaIcons.FaBalanceScale />,
        cName: "nav-text2",
      },
    ],
  },
*/
];
